import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';
import { NoValidatorError } from 'src/fieldFormControl/validators/ValidatorErrors';

export class SharedValidatorsFactory {
  static getValidator(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn | undefined {
    switch (validatorKey) {
      case 'fraisVersement':
        return fraisParDefautMaximum(fieldKey, validatorKey, config);
      case 'champObligatoire':
        return champObligatoire(fieldKey, validatorKey, config);

      default:
        throw new NoValidatorError(fieldKey, validatorKey);
    }
    return undefined;
  }
}

function fraisParDefautMaximum(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validatorConfig = config.currentFormConfigSubject.value?.fieldConfigs
      ?.find(config => config.fieldKey === fieldKey)
      ?.validators?.find(validator => validator.validatorKey === validatorKey);
    if (!validatorConfig) {
      return null;
    }
    const pourcentMax = Number(
      validatorConfig?.parameters?.find(parameter => parameter.key === 'tauxParDefaut')?.value ?? '0'
    );
    if (control instanceof FieldFormControl) {
      const formControl = control as FieldFormControl<number, number>;
      const value = formControl.value;
      if (value > pourcentMax) {
        return { custom: 'true', code: validatorKey };
      }
    }

    return null;
  };
}

function champObligatoire(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control instanceof FieldFormControl) {
      const formControl = control as FieldFormControl<number, number>;
      const value = formControl.value;
      if (value === null || value === undefined) {
        return { custom: 'true', code: validatorKey };
      }
    }
    return null;
  };
}
